export {
  default as ExtendedBitmapText,
} from './com/candywings/i18n/extensions/ExtendedBitmapText';
export {
  default as ExtendedDynamicBitmapText,
} from './com/candywings/i18n/extensions/ExtendedDynamicBitmapText';
export {
  default as ExtendedText,
} from './com/candywings/i18n/extensions/ExtendedText';
export {
  ExtendedBitmapTextConfig,
  ExtendedDynamicBitmapTextConfig,
  ExtendedTextConfig,
  I18nConfig,
  I18nCreator,
  I18nFactory,
  I18nGame,
  I18nGameInterface,
  I18nLanguageData as I18nLangaugeData,
  I18nScene,
  I18nSceneInterface,
} from './com/candywings/i18n/extensions/Interfaces';
export { default as I18nPlugin } from './com/candywings/i18n/plugin/I18nPlugin';
